import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhp,
  faHtml5,
  faCss3,
  faReact,
  faJsSquare,
  faGitAlt,
} from "@fortawesome/free-brands-svg-icons";
import Loader from "react-loaders";

const About = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  // Calculate years dynamically
  const calculateYears = (startYear) => {
    const currentYear = new Date().getFullYear();
    return currentYear - startYear;
  };

  const yearsOfExperience = calculateYears(2020);

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["A", "b", "o", "u", "t", " ", "m", "e"]}
              idx={15}
            />
          </h1>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1, // Allow the content to grow and fill the space
              overflowY: 'auto', // Enable scrolling
              boxSizing: 'border-box',
            }}
          >
            <p>
              I'm a dedicated and results-driven full-stack developer with over <strong>{yearsOfExperience} years</strong> of industry experience, specializing in creating engaging, user-centered websites and mobile applications. With a strong command of both front-end and back-end technologies, I bring a holistic approach to each project, ensuring a seamless user experience from start to finish.
            </p>
            <p align="left">
              I pride myself on my meticulous attention to detail and my commitment to high-quality work. With a problem-solving mindset, I tackle challenges with confidence, delivering creative and effective solutions that meet project goals. My communication skills allow me to build strong, productive relationships with clients and team members, facilitating smooth collaboration and driving project success.
            </p>
            <p>
              Passionate about innovation, I stay up-to-date with emerging technologies and trends, constantly exploring new ways to enhance the digital experience. My goal is to create meaningful and impactful digital solutions that not only meet but exceed expectations.
            </p>
            <p>
              If you’re looking for a developer who can bring your ideas to life with precision and creativity, let’s connect! Together, we can build something exceptional.
            </p>
          </div>
        </div>
        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faPhp} color="#28a4d9" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>

      <Loader type="pacman" />
    </>
  );
};

export default About;
